/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon24Regular = forwardRef('CheckCircleCutIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.418 2.555a9.75 9.75 0 1 0 7.293 10.316.75.75 0 0 0-1.494-.134 8.25 8.25 0 1 1-6.17-8.73.75.75 0 0 0 .371-1.452Z" }),
        React.createElement("path", { d: "M21.535 6.191a.75.75 0 1 0-1.06-1.06l-8.05 8.049c-.439.439-1.151.439-1.59 0l-2.987-2.987a.75.75 0 0 0-1.06 1.06l2.986 2.987a2.625 2.625 0 0 0 3.712 0l8.05-8.049Z" })));
});
